module.exports = __webpack_public_path__ + "static/media/bg.7af88390.jpg";